import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ChecklistRescheduleDto, type ChecklistRescheduleInterface } from '@zaoblako/shared/modules/project/dto/checklist/checklist-reschedule.dto';
import type { ProjectFindInterface } from '@zaoblako/shared/modules/project/dto/project/project-find.dto';
import { ProjectStoreService } from '@zaoblako/web/modules/project/components/project/card/services/project-store.service';
import { ChecklistPeriodFormComponent } from '@zaoblako/web/modules/project/dumbs/checklist-period-form/checklist-period-form.component';
import { BaseFormComponent } from '@zaoblako/web/shared/dumbs/base-form/base-form.component';
import { EditorComponent } from '@zaoblako/web/shared/dumbs/editor/editor.component';
import { JoinPipe } from '@zaoblako/web/shared/pipes/join.pipe';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'crm-checklist-reschedule-form',
  standalone: true,
  imports: [CommonModule, JoinPipe, ButtonModule, EditorComponent, ChecklistPeriodFormComponent],
  templateUrl: './checklist-reschedule-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChecklistRescheduleFormComponent extends BaseFormComponent<ChecklistRescheduleInterface> implements OnChanges {
  public engine: 'class-transformer' | 'serde' = 'serde';

  @Input() public info = <ChecklistRescheduleInterface>{};
  @Input() public project = <ProjectFindInterface>{};
  @Input() public isExtendTime = false;
  public dto = ChecklistRescheduleDto;

  public isError = null;

  public constructor(private readonly projectStoreService: ProjectStoreService) {
    super();
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.info?.currentValue) {
      this.checkDeadlineError();
    }
    if (this.project?.id && changes.project?.currentValue) {
      this.checkDeadlineError();
    }
  }

  public checkDeadlineError() {
    const projectDeadline = this.projectStoreService.getProject?.deadline || this.project?.deadline;
    if (projectDeadline && !this.canDelete) {
      const deadline = new Date(projectDeadline);
      const date = new Date(this.info.startAt);
      this.isError =
        date.getTime() >= deadline.getTime() ? 'Дата начала события не может быть позже дедлайна задачи' : null;
    }
  }

  public onSave(info: ChecklistRescheduleInterface) {
    if (!this.isError) {
      super.onSave(info);
    }
  }
}
